import {connect} from 'react-redux';
import App from '../../components/App';
import {loadArticles, hasResults, sending} from '../../actions';
import {withRouter} from 'react-router-dom';
import {articlesSelector} from '../../selectors/articles';

function mapStateToProps(state) {
  return {
    articles: articlesSelector(state),
    experiments: state.experiments.active,
    basePath: state.articles.basePath || state.article.basePath
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadArticles: (tag, page, search) => dispatch(loadArticles(tag, page, search)),
    hasResults: mode => dispatch(hasResults(mode)),
    sending: mode => dispatch(sending(mode))
  };
}
export default withRouter(<any>connect(mapStateToProps, mapDispatchToProps)(App));
